<template>
  <section class="team">
    <ul>
      <li
        class="list"
        v-for="(person, i) in team"
        :key="i"
        @mouseenter="showImage(person.img)"
        @mouseleave="hideImage"
        @mousemove="moveCursor"
      >
        <div class="team-item">
          <div class="team-img">
            <!-- <img :src="person.img" width="70px" height="70px" class="rounded-full"/> -->
            <img v-if="person.img" :src="require(`@/assets${person.img}`)" width="70px" height="70px"/>
          </div>
          <div class="team-content">
            <span class="team-name">{{ person.name }}</span>
            <span class="team-position">{{ person.position[$i18n.locale] }}</span>
          </div>
        </div>
      </li>
    </ul>

    <!-- Imagen flotante para el hover -->
    <div ref="cursorImg" class="cursor-img" v-show="hoverImg" :style="{ left: cursorX + 'px', top: cursorY + 'px' }">
      <img :src="hoverImg" alt="Profile Image">
    </div>
  </section>
</template>

<script>
import team from '@/assets/js/team.json'

export default {
  data () {
    return {
      team,
      hoverImg: null, // Imagen que se mostrará en el hover
      cursorX: 0, // Posición del cursor en el eje X
      cursorY: 0, // Posición del cursor en el eje Y
      isHovering: false // Variable para controlar si estamos sobre un <li>
    }
  },
  methods: {
    showImage (img) {
      this.isHovering = true

      if (this.hoverImg !== img) {
        try {
          this.hoverImg = require(`@/assets${img}`)
          this.$nextTick(() => {
            if (this.$refs.cursorImg) {
              this.$refs.cursorImg.style.opacity = '1'
              this.$refs.cursorImg.style.transform = 'scale(1)'
            }
          })
        } catch (error) {
          this.hoverImg = null
        }
      }
    },

    hideImage () {
      this.isHovering = false // Estamos saliendo del <li>

      setTimeout(() => {
        if (!this.isHovering) { // Solo oculta la imagen si no estamos en otro <li>
          if (this.$refs.cursorImg) {
            this.$refs.cursorImg.style.opacity = '0'
            this.$refs.cursorImg.style.transform = 'scale(0)'
          }
          this.hoverImg = null
        }
      }, 150) // Pequeño delay para evitar parpadeo
    },

    moveCursor (event) {
      this.cursorX = event.clientX - 50
      this.cursorY = event.clientY - 50
    }
  }

}
</script>

<style lang="scss" scoped>
.team {
  width: 100%;
  min-height: 100vh;
  margin-top: 8rem;

  ul {
    li {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      position: relative;
      z-index: 1;
      transition: all 0.3s ease-in-out;

      &:after {
        position: absolute;
        content: "";
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: $main-color;
        transform: scaleY(0);
        transform-origin: top;
        transition: transform 0.6s cubic-bezier(0.19,1,0.22,1);
        z-index: 0;
      }

      &:hover {
        &::after {
          transform: scaleY(1);
          transform-origin: bottom;
        }
        .team-name {
          color: #fff;
          transform: translateX(20px);
        }
        .team-position {
          color: #fff;
        }
      }
    }
  }
}

.team-item {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: var(--main-space);
  // padding-right: 1rem;
  z-index: 10;
}

.team-img {
  display: flex;
  margin-right: 1rem;
  border-radius: 70px;
  overflow: hidden;
  min-width: 70px;

  @media (min-width: 640px) {
    display: none;
  }
}

.team-content {
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: space-between;
  align-items: flex-start;

  @media (min-width: 640px) {
    flex-direction: row;
    align-items: center;
  }
}

.team-name {
  font-size: 1rem;
  line-height: 1.4;
  color: #fff;
  transition: transform 0.6s cubic-bezier(0.19,1,0.22,1);

  @media (min-width: 640px) {
    font-size: 21px;
    color: $main-color;
  }
}

.team-position {
  font-size: 0.875rem;
  line-height: 1.4;
  color: #fff;

  @media (min-width: 640px) {
    font-size: 21px;
    color: $main-color;
  }
}

.cursor-img {
  position: fixed;
  width: 340px;
  height: 340px;
  border-radius: 50%;
  overflow: hidden;
  pointer-events: none;
  z-index: 1000;
  opacity: 0;
  transition: opacity 0.3s ease-in-out, transform 0.3s ease-in-out;
  // transform: translate(-50px, -50px), scale(0);
  transform: scale(0);
  margin:(-340px * 0.5) 0 0 (-340px * 0.5);

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.cursor-img {
  opacity: 1;
}

@media (max-width: 640px) {
  .cursor-img {
    display: none;
  }
}

@media (max-width: 640px) {
  .team {
    ul {
      li {
        &:hover .team-name {
          transform: translateX(0px);
        }
      }
    }
  }

  .team-icon svg {
    width: 20px;
    height: 20px;

    &:deep(path) {
      fill: $main-color!important;
    }
  }
}
</style>
